import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen radar-grid-bg flex items-center justify-center">
        <div className="text-center">
          <div className="radar-sweep mx-auto mb-4"/>
          <div className="kpi-label text-[#0A84FF]">/ VERIFYING SESSION</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default ProtectedRoute;
